
import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import Layout from '../Home'
import CreateDoctorTypeForm from '../../components/DoctorTypeForm'


@inject('DoctorTypes')
@observer
class CreateDoctorType extends Component {
  state = {
    hasSubmitted: false,
  }


  handleSubmit = async (values) => {
    const { DoctorTypes, history } = this.props
    const response = await DoctorTypes.createDoctorType(values)
    if (response) {
      this.setState({ hasSubmitted: true })
    }
    history.goBack()
  }

  render() {
    const { hasSubmitted } = this.state

    return (
      <Layout
        {...this.props}
        render={(props) => (
          <CreateDoctorTypeForm
            onSubmit={this.handleSubmit}
            hasSubmitted={hasSubmitted}
            title="Create Doctor Type"
            {...props}
            style={{ width: '100%' }}
          />
        )}
      />
    )
  }
}

CreateDoctorType.propTypes = {
}

CreateDoctorType.defaultProps = {
}

export default CreateDoctorType
